const state = {
  shopList: [],
  menuList: []
}

const getters = {
  shopList: (state) => state.shopList,
  menuList: (state) => state.menuList
}

const mutations = {
  SET_SHOP_LIST(state, shop) {
    state.shopList.push(shop)
  },
  SET_MENU_LIST(state, shop) {
    state.menuList.push(shop)
  },
  REMOVE_SHOP_LIST() {
    state.shopList = []
  }
}

const actions = {
  setShopList({ commit }, shop) {
    commit('SET_SHOP_LIST', shop)
  },
  setMenuList({ commit }, shop) {
    commit('SET_MENU_LIST', shop)
  },
  removeShopList({ commit }) {
    commit('REMOVE_SHOP_LIST')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
